import type { Maybe } from '@adornis/base/utilTypes.js';
import { BooleanAspect } from '@adornis/filter/aspect-schemas/BooleanAspect.js';
import { StringAspect } from '@adornis/filter/aspect-schemas/StringAspect.js';
import { ChancenwerkUserFilter } from '@chancenwerk/db/filter/ChancenwerkUserFilter.js';
import '@chancenwerk/design/components/cr-flex.js';
import { ExternerMitarbeiter } from '@chancenwerk/master-data-management/users/entities/ExternerMitarbeiter.js';
import { Mitarbeiter } from '@chancenwerk/master-data-management/users/entities/Mitarbeiter.js';
import { VerwaltungsMitarbeiter } from '@chancenwerk/master-data-management/users/entities/VerwaltungsMitarbeiter.js';
import { BehaviorSubject } from 'rxjs';

export const teacherDashboardStudentFilter = new BehaviorSubject<ChancenwerkUserFilter>(
  new ChancenwerkUserFilter({
    aspects: [
      new StringAspect({
        fieldName: '_class',
        value: 'Student',
      }),
    ],
    search: null,
  }),
);
export const teacherDashboardWorkGroup = new BehaviorSubject<Maybe<string>>(null);

export const teacherDashboardEmployeeFilter = new BehaviorSubject<ChancenwerkUserFilter>(
  new ChancenwerkUserFilter({
    userClass: [Mitarbeiter._class, ExternerMitarbeiter._class, VerwaltungsMitarbeiter._class],
    aspects: [new BooleanAspect({ customID: 'active', value: true })],
    search: null,
  }),
);

teacherDashboardStudentFilter.subscribe();
teacherDashboardWorkGroup.subscribe();
teacherDashboardEmployeeFilter.subscribe();
